<template lang="pug">
.sticker-collection-loading-bar(role="status" aria-label="Loading collection")
  .loading-track
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StickerCollectionLoadingBar',
});
</script>

<style lang="scss" scoped>
.sticker-collection-loading-bar {
  margin: 0.75rem 0 1.25rem;
}

.loading-track {
  height: 0.375rem;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    #e5e7eb 0%,
    #f3f4f6 40%,
    #e5e7eb 80%
  );
  background-size: 200% 100%;
  animation: collection-shimmer 1.2s ease-in-out infinite;
}

@keyframes collection-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
